import { gql } from "@apollo/client";

export const GET_ALL_REFERRALS_BY_ORG_ID = gql`
  query ($orgId: String!) {
    getAllReferralsByOrgID(id: $orgId) {
      id
      from
      user {
        id
        firstName
        lastName
        email
      }
      userId
      eligibilityStatus
      serviceId
      serviceName
      orgId
      status
      isSelfReferral
    }
  }
`;
